import {
  LEAD_DEAL_DONE_ID,
  LEAD_VIEWING_ARRANGE_ID,
  LEAD_VIEWING_DONE_ID,
  STATUS_TYPES,
} from "../../constants/leads";
import { Chip, MenuItem, TextField, Tooltip } from "@mui/material";
import { AGENT_IMAGES_URL, PROPERTY_IMAGES_URL } from "../../constants/url";
import React, { useState } from "react";
import { correctDate } from "../../constants/customFunction";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EDIT_LEAD_ROUTE } from "../../constants/routes";
import StatusDescription from "./status/StatusDescription";
import { useStatusQuery } from "../../redux/api/leadsApi";
import dayjs from "dayjs";
import { isDisabled } from "../../helper/agentRights";
import { selectCurrentAgent } from "../../redux/features/authSlice";
import { useSelector } from "react-redux";

export const PROPERTY_LEADS_COLUMNS = [
  {
    header: "Staff",
    accessorKey: "agentimage",
    Cell: ({ row }) => (
      <div>
        <img
          src={AGENT_IMAGES_URL + row.original.agentimage}
          alt={"Staff"}
          style={{ width: "70px", height: "70px" }}
        />
      </div>
    ),
    size: 30,
  },
  {
    accessorKey: "agentname",
    header: "Staff Name",
    size: 20,
  },
  {
    accessorKey: "agentphone",
    header: "Staff Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.agentphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.agentphone}
      </a>
    ),
  },
  // {
  //   accessorKey: "leadSerialNo",
  //   header: "S.No",
  //   size: 30,
  // },
  {
    accessorKey: "leadUpdatedDate",
    header: "Updated Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.leadUpdatedDate).toLocaleDateString()}</div>
    ),
  },
  {
    accessorKey: "Lead ID",
    header: "Lead ID",
    size: 20,
    Cell: ({ row }) => {
      const propertyrefnum = row.original.propertyrefnum || "";
      const leadName = propertyrefnum ? propertyrefnum.split("-")[0] : "";
      const leadId = row.original.leadid;

      const getLeadIdBackgroundColor = (leadTime) => {
        const now = dayjs(); // Current time
        const leadDate = dayjs(leadTime); // Lead time
        const diffInHours = now.diff(leadDate, "hour");

        if (diffInHours < 24) {
          return ""; // Green for less than 24 hours
        } else if (diffInHours >= 24 && diffInHours < 48) {
          return "orange"; // Orange for 24 to 48 hours
        } else {
          return "red"; // Red for more than 48 hours
        }
      };
      const backgroundColor = getLeadIdBackgroundColor(
        row.original.leadUpdatedDate
      );

      return (
        <div>
          <Chip
            label={`${leadName ? `${leadName}-L-${leadId}` : `L-${leadId}`}`}
            size="small"
            sx={{
              cursor: "pointer",
              fontSize: 12,
              backgroundColor: backgroundColor || "#56C662", // Use the calculated color or default
              color: "white",
            }}
          />
        </div>
      );
    },
  },
  {
    accessorKey: "firstname",
    header: "First Name",
    size: 20,
  },
  {
    accessorKey: "lastname",
    header: "Last Name",
    size: 20,
  },
  // {
  //   accessorKey: "leadSerialNo",
  //   header: "S.No",
  //   size: 20,
  // },
  {
    accessorKey: "statusName",
    header: "Lead Status",
    size: 20,
  },
  {
    header: "Note",
    accessorKey: "note",
    Cell: ({ row }) => (
      <div>
        <Tooltip title={row.original.note} placement="top">
          <div
            style={{
              width: "150px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {row.original.note}
          </div>
        </Tooltip>
      </div>
    ),
    size: 30,
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },
  {
    accessorKey: "userphone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },
  {
    accessorKey: "PriorityName",
    header: "Priority Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },
  {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },
  {
    accessorKey: "LeadTypeName",
    header: "Lead Type",
    size: 20,
  },
  {
    accessorKey: "MediumName",
    header: "Medium Name",
    size: 20,
  },
  {
    accessorKey: "SourceName",
    header: "Source Type",
    size: 20,
  },
  {
    accessorKey: "Description",
    header: "Description",
    size: 10,
    Cell: ({ row }) => (
      <div>
        <Tooltip title={row.original.description} placement="top">
          <div
            style={{
              whiteSpace: "nowrap",
              width: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {row.original?.description}
          </div>
        </Tooltip>
      </div>
    ),
  },
  {
    accessorKey: "leadTime",
    header: "Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.leadTime).toLocaleDateString()}</div>
    ),
  },
  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },
  {
    accessorKey: "propertyid",
    header: "Property Image",
    size: 20,
    Cell: ({ row }) => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
          }}
        >
          <img
            src={`${PROPERTY_IMAGES_URL}${row.original.images}`}
            alt="property"
            style={{ maxHeight: "40px" }}
          />
          {/* <Chip label={row.original.propertyrefnum} size="small" sx={{ cursor: 'pointer', fontSize: 12 }} color="secondary" /> */}
        </div>
      );
    },
  },
];
export const ALL_LEADS_COLUMNS = (refetch) => [
  // {
  //   accessorKey: "leadSerialNo",
  //   header: "S.No",
  //   size: 20,
  // },
  // {
  //   header: "Staff",
  //   accessorKey: "agentimage",
  //   Cell: ({ row }) => (
  //     <div>
  //       <img
  //         src={AGENT_IMAGES_URL + row.original.agentimage}
  //         alt={"Staff"}
  //         style={{ width: "70px", height: "70px" }}
  //       />
  //     </div>
  //   ),
  //   size: 30,
  // },
  {
    accessorKey: "agentname",
    header: "Staff Name",
    size: 20,
  },

 {
     accessorKey: "leadTag",
     header: "Lead Ref No",
     size: 20,
     Cell: ({ row }) => {
       const currentAgent = useSelector(selectCurrentAgent);
       const leadId = row.original?.leadid;
 
       // If no leadId, show nothing (keeps row height consistent)
       if (!leadId) return <div style={{ minHeight: 24 }} />;
 
       const getLeadIdBackgroundColor = (leadTime) => {
         const now = dayjs();
         const leadDate = dayjs(leadTime);
         const diffInHours = now.diff(leadDate, "hour");
 
         if (diffInHours < 24) return "";
         else if (diffInHours >= 24 && diffInHours < 48) return "orange";
         else return "red";
       };
 
       const backgroundColor = getLeadIdBackgroundColor(
         row.original?.followupdate
       );
 
       // Build safe label (avoid showing undefined)
       const tagPrefix = currentAgent?.agcRefTag
         ? `${currentAgent.agcRefTag}-`
         : "";
       const label = `${tagPrefix}L-${leadId}`;
 
       return (
         <Chip
           label={label}
           size="small"
           sx={{
             cursor: "pointer",
             fontSize: 12,
             backgroundColor: backgroundColor || "#56C662",
             color: "white",
           }}
         />
       );
     },
   },
 
  {
    accessorKey: "leadUpdatedDate",
    header: "Updated Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.leadUpdatedDate;
      if (!value) return null;

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
  },

  {
    accessorKey: "followupdate",
    header: "Follow up Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.followupdate;
      if (!value) return "Not Scheduled";

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
  },
  {
    accessorKey: "firstname", // keep this for filtering
    header: "Full Name",
    size: 30,
    Cell: ({ row }) => {
      const first = row.original.firstname || "";
      const last = row.original.lastname || "";
      const fullName = `${first} ${last}`.trim();

      return (
        <div
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2, // ✅ limit to 2 lines max
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
          {fullName || "—"}
        </div>
      );
    },
    filterFn: "includesString", // ensures filtering still uses firstname
  },

  {
    accessorKey: "userphone",
    header: "Lead Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },
  {
    accessorKey: "leadStatus",
    header: "Status",
    size: 25,
    Cell: ({ row }) => {
      const [status, setStatus] = useState(
        row.original.leadStatus?.toString() || ""
      );
      const [updatedStatus, setUpdatedStatus] = useState(status);
      const [updatedStatusName, setUpdatedStatusName] = useState(status);
      const [showComponent, setShowComponent] = useState(false);
      const navigate = useNavigate();
      const { data: STATUS = [] } = useStatusQuery();

      const handleChange = (event) => {
        const newStatus = event.target.value;
        setUpdatedStatus(newStatus);
        setShowComponent(true);
        setUpdatedStatusName(
          STATUS.find((item) => item.statusId === newStatus)?.statusName || ""
        );
        const currentPath = window.location.pathname;
        let newPath;
        if (newStatus === LEAD_VIEWING_ARRANGE_ID) {
          newPath = `/leads/view/${row.original.userid}/viewingarranged/${row.original.leadid}`;
        }
        if (newStatus === LEAD_VIEWING_DONE_ID) {
          newPath = `/leads/view/${row.original.userid}/viewdone/${row.original.leadid}`;
        }
        if (newStatus === LEAD_DEAL_DONE_ID) {
          newPath = `/leads/view/${row.original.userid}/deal/${row.original.leadid}`;
        }
        navigate(newPath);
      };

      return (
        <>
          <TextField
            variant="outlined"
            size="small"
            select
            value={status}
            onChange={handleChange}
            SelectProps={{
              displayEmpty: true,
              MenuProps: {
                sx: { maxHeight: "380px" },
                PaperProps: {
                  sx: {
                    maxWidth: 180, // limit dropdown width
                    "& .MuiMenuItem-root": {
                      whiteSpace: "normal", // ✅ allow wrapping
                      wordBreak: "break-word", // ✅ break long words
                      lineHeight: 1.3,
                      py: 0.8,
                    },
                  },
                },
              },
              renderValue: () => {
                const selectedStatus = STATUS.find(
                  (option) => option.statusId.toString() === status?.toString()
                );
                return selectedStatus ? (
                  <span
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      lineHeight: 1.2,
                      display: "inline-block",
                    }}
                  >
                    {selectedStatus.statusName}
                  </span>
                ) : (
                  <span>Status</span>
                );
              },
            }}
            sx={{ width: "180px" }} // ✅ smaller width now works well
          >
            {STATUS?.map((option) => (
              <MenuItem
                key={option.statusId}
                value={option.statusId}
                sx={{
                  whiteSpace: "normal", // ✅ wrap text into 2–3 lines
                  wordBreak: "break-word",
                  lineHeight: 1.3,
                }}
              >
                {option.statusName}
              </MenuItem>
            ))}
          </TextField>

          {showComponent && (
            <div className="fixed top-0 left-0 xl:top-5 xl:left-20 flex items-center justify-center w-full h-[100vh] z-10 bg-customGray">
              <div className="w-auto sm:w-[600px] h-[350px] bg-white rounded-xl flex flex-col justify-center items-center">
                <StatusDescription
                  setShowVerify={setShowComponent}
                  selectedLeadStatus={updatedStatus}
                  selectedLeadStatusName={updatedStatusName}
                  leadData={row.original}
                  setStatus={setStatus}
                  refetch={refetch} // ✅ pass refetch properly
                />
              </div>
            </div>
          )}
        </>
      );
    },
  },
  {
    header: "Note",
    accessorKey: "note",
    Cell: ({ row }) => {
      const note = row.original.note || "—";

      return (
        <Tooltip title={note} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {note}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },
  {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },

  {
    accessorKey: "PriorityName",
    header: "Priority Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },

  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },

  {
    accessorKey: "LeadTypeName",
    header: "Lead Type",
    size: 20,
  },

  {
    accessorKey: "MediumName",
    header: "Medium Name",
    size: 20,
  },
  {
    accessorKey: "SourceName",
    header: "Source Type",
    size: 20,
  },

  {
    accessorKey: "Description",
    header: "Description",
    size: 10,
    Cell: ({ row }) => (
      <div>
        <Tooltip title={row.original.note} placement="top">
          <div
            style={{
              whiteSpace: "nowrap",
              width: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {row.original?.description}
          </div>
        </Tooltip>
      </div>
    ),
  },

  {
    accessorKey: "leadTime",
    header: "Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.leadTime).toLocaleDateString()}</div>
    ),
  },

  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },

  {
    accessorKey: "propertydata",
    header: "Property",
    size: 15,
    Cell: ({ row }) => {
      const { id } = useParams();
      return row.original.propertyid === null ? (
        <span>Disable</span>
      ) : (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`/leads/view/${row.original?.userid}/details/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Details
          </span>
        </Link>
      );
    },
  },
  {
    accessorKey: "edit",
    header: "Edit",
    size: 15,
    Cell: ({ row }) => {
      const currentAgent = useSelector(selectCurrentAgent);
      const agentRights = currentAgent.agentrights || {};
      const canUpdateLead = !isDisabled(agentRights, "Update Lead");

      return canUpdateLead ? (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={EDIT_LEAD_ROUTE + row.original.leadid}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Edit
          </span>
        </Link>
      ) : (
        <Tooltip title="You don't have permission to edit leads">
          <span className="inline-flex items-center rounded bg-gray-400 px-4 py-1 text-white text-sm cursor-not-allowed opacity-60">
            Edit
          </span>
        </Tooltip>
      );
    },
  },
];

export const LEADS_POOL_COLUMNS = [
  // {
  //   accessorKey: "leadSerialNo",
  //   header: "S.No",
  //   size: 30,
  // },
  {
    accessorKey: "firstname",
    header: "First Name",
    size: 20,
  },
  {
    accessorKey: "lastname",
    header: "Last Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "userphone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },
  {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },
  {
    accessorKey: "userid",
    header: "User Id",
    size: 20,
  },
  {
    accessorKey: "leadid",
    header: "Lead Id",
    size: 20,
    // Cell: ({ row }) => <span>{row.original?.Properties[0]?.leadid}</span>,
  },

  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
];

export const VIEW_COLUMNS = (refetch) => [
  
  {
    accessorKey: "leadTag",
    header: "Lead Ref No",
    size: 20,
    Cell: ({ row }) => {
      const currentAgent = useSelector(selectCurrentAgent);
      const leadId = row.original.leadid;

      const getLeadIdBackgroundColor = (leadTime) => {
        const now = dayjs(); // Current time
        const leadDate = dayjs(leadTime); // Lead time
        const diffInHours = now.diff(leadDate, "hour");

        if (diffInHours < 24) {
          return ""; // Green for less than 24 hours
        } else if (diffInHours >= 24 && diffInHours < 48) {
          return "orange"; // Orange for 24 to 48 hours
        } else {
          return "red"; // Red for more than 48 hours
        }
      };
      const backgroundColor = getLeadIdBackgroundColor(
        row.original.followupdate
      );

      return (
        <div>
          <Chip
            label={`${currentAgent.agcRefTag}-L-${leadId}`}
            size="small"
            sx={{
              cursor: "pointer",
              fontSize: 12,
              backgroundColor: backgroundColor || "#56C662", // Use the calculated color or default
              color: "white",
            }}
          />
        </div>
      );
    },
  },

  {
    accessorKey: "leadUpdatedDate",
    header: "Updated Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.leadUpdatedDate;
      if (!value) return null;

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
    filterFn: "includesString",
  },

  {
    accessorKey: "followupdate",
    header: "Follow up Date",
    size: 10,
    Cell: ({ row }) => {
      const value = row.original.followupdate;
      if (!value) return "Not Scheduled";

      const date = new Date(value);
      const dateStr = date.toLocaleDateString();
      const timeStr = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return (
        <div
          style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}
        >
          <span>{dateStr}</span>
          <span style={{ fontSize: "0.8rem", color: "gray" }}>{timeStr}</span>
        </div>
      );
    },
    filterFn: "includesString",
  },

  {
    accessorKey: "firstname", // keep this for filtering
    header: "Full Name",
    size: 30,
    Cell: ({ row }) => {
      const first = row.original.firstname || "";
      const last = row.original.lastname || "";
      const fullName = `${first} ${last}`.trim();

      return (
        <div
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2, // ✅ limit to 2 lines max
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
          {fullName || "—"}
        </div>
      );
    },
    filterFn: "includesString", // ensures filtering still uses firstname
  },

  {
    accessorKey: "userphone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.userphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.userphone}
      </a>
    ),
  },
  {
    accessorKey: "history",
    header: "History",
    size: 20,
    Cell: ({ row }) => {
      const currentPath = window.location.pathname;
      const segments = currentPath.split("/");
      return (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`/${row.original?.userid}/history/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>

          <span className="text-sm font-medium transition-all group-hover:ms-4">
            {" "}
            History{" "}
          </span>
        </Link>
      );
    },
  },
  {
    accessorKey: "leadStatus",
    header: "Status",
    size: 20,
    Cell: ({ row }) => {
      const [status, setStatus] = useState(
        row.original.leadStatus?.toString() || ""
      );
      const [updatedStatus, setUpdatedStatus] = useState(status);
      const [updatedStatusName, setUpdatedStatusName] = useState(status);
      const [showComponent, setShowComponent] = useState(false);
      const navigate = useNavigate();
      const { data: STATUS = [] } = useStatusQuery();

      const handleChange = (event) => {
        const newStatus = event.target.value;
        setUpdatedStatus(newStatus);
        setShowComponent(true);
        setUpdatedStatusName(
          STATUS.find((item) => item.statusId === newStatus)?.statusName || ""
        );

        const currentPath = window.location.pathname;
        let newPath;
        if (newStatus === LEAD_VIEWING_ARRANGE_ID) {
          newPath = `${currentPath}/view/${row.original.userid}/viewingarranged/${row.original.leadid}`;
        }
        if (newStatus === LEAD_VIEWING_DONE_ID) {
          newPath = `${currentPath}/view/${row.original.userid}/viewdone/${row.original.leadid}`;
        }
        if (newStatus === LEAD_DEAL_DONE_ID) {
          newPath = `${currentPath}/view/${row.original.userid}/deal/${row.original.leadid}`;
        }
        navigate(newPath);
      };

      return (
        <>
          <TextField
            variant="outlined"
            size="small"
            select
            value={status}
            onChange={handleChange}
            SelectProps={{
              displayEmpty: true,
              MenuProps: {
                sx: { maxHeight: "380px" },
                PaperProps: {
                  sx: {
                    maxWidth: 180, // limit dropdown width
                    "& .MuiMenuItem-root": {
                      whiteSpace: "normal", // ✅ allow wrapping
                      wordBreak: "break-word", // ✅ break long words
                      lineHeight: 1.3,
                      py: 0.8,
                    },
                  },
                },
              },
              renderValue: () => {
                const selectedStatus = STATUS.find(
                  (option) => option.statusId.toString() === status?.toString()
                );
                return selectedStatus ? (
                  <span
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      lineHeight: 1.2,
                      display: "inline-block",
                    }}
                  >
                    {selectedStatus.statusName}
                  </span>
                ) : (
                  <span>Status</span>
                );
              },
            }}
            sx={{ width: "180px" }} // ✅ smaller width now works well
          >
            {STATUS?.map((option) => (
              <MenuItem
                key={option.statusId}
                value={option.statusId}
                sx={{
                  whiteSpace: "normal", // ✅ wrap text into 2–3 lines
                  wordBreak: "break-word",
                  lineHeight: 1.3,
                }}
              >
                {option.statusName}
              </MenuItem>
            ))}
          </TextField>

          {showComponent && (
            <div className="fixed top-0 left-0 xl:top-5 xl:left-20 flex items-center justify-center w-full h-[100vh] z-10 bg-customGray">
              <div className="w-auto sm:w-[600px] h-[350px] bg-white rounded-xl flex flex-col justify-center items-center">
                <StatusDescription
                  setShowVerify={setShowComponent}
                  selectedLeadStatus={updatedStatus}
                  selectedLeadStatusName={updatedStatusName}
                  leadData={row.original}
                  setStatus={setStatus}
                  refetch={refetch} // ✅ pass refetch properly
                />
              </div>
            </div>
          )}
        </>
      );
    },
  },

  {
    header: "Note",
    accessorKey: "note",
    Cell: ({ row }) => {
      const note = row.original.note || "—";

      return (
        <Tooltip title={note} placement="top">
          <div
            style={{
              width: "220px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2, // ✅ limits text to 2 lines
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
              lineHeight: 1.3,
            }}
          >
            {note}
          </div>
        </Tooltip>
      );
    },
    size: 30,
  },

  {
    accessorKey: "whatsappNo",
    header: "Whatsapp No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`https://wa.me/${row.original.whatsappNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.whatsappNo}
      </a>
    ),
  },
  {
    accessorKey: "additionalNo",
    header: "Additional No",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.additionalNo}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.additionalNo}
      </a>
    ),
  },
  {
    accessorKey: "budget",
    header: "Budget",
    size: 20,
  },

  {
    accessorKey: "PriorityName",
    header: "Priority Name",
    size: 20,
  },
  {
    accessorKey: "societyName",
    header: "Society Name",
    size: 20,
  },
  {
    accessorKey: "fileNo",
    header: "File No",
    size: 20,
  },
  {
    accessorKey: "block",
    header: "Block",
    size: 20,
  },
  {
    accessorKey: "plotNo",
    header: "Plot No",
    size: 20,
  },
  {
    accessorKey: "plotSize",
    header: "Plot Size",
    size: 20,
  },
  {
    accessorKey: "type",
    header: "Type",
    size: 20,
  },

  {
    accessorKey: "membershipId",
    header: "Membership Id",
    size: 20,
  },
  {
    accessorKey: "useremail",
    header: "Email",
    size: 20,
  },
  {
    accessorKey: "companyName",
    header: "Company Name",
    size: 20,
  },
  {
    accessorKey: "location",
    header: "Location",
    size: 20,
  },
  {
    accessorKey: "designation",
    header: "Designation",
    size: 20,
  },

  {
    accessorKey: "LeadTypeName",
    header: "Lead Type",
    size: 20,
  },

  {
    accessorKey: "MediumName",
    header: "Medium Name",
    size: 20,
  },
  {
    accessorKey: "SourceName",
    header: "Source Type",
    size: 20,
  },

  {
    accessorKey: "Description",
    header: "Description",
    size: 10,
    Cell: ({ row }) => (
      <div>
        <Tooltip title={row.original.note} placement="top">
          <div
            style={{
              whiteSpace: "nowrap",
              width: "250px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {row.original?.description}
          </div>
        </Tooltip>
      </div>
    ),
  },

  {
    accessorKey: "leadTime",
    header: "Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.leadTime).toLocaleDateString()}</div>
    ),
  },

  {
    accessorKey: "propertyrefnum",
    header: "Property Ref Num",
    size: 20,
  },

  {
    accessorKey: "propertydata",
    header: "Property",
    size: 15,
    Cell: ({ row }) => {
      const { id } = useParams();
      return row.original.propertyid === null ? (
        <span>Disable</span>
      ) : (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={`/leads/view/${row.original?.userid}/details/${row.original.leadid}`}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Details
          </span>
        </Link>
      );
    },
  },
  {
    accessorKey: "edit",
    header: "Edit",
    size: 15,
    Cell: ({ row }) => {
      const currentAgent = useSelector(selectCurrentAgent);
      const agentRights = currentAgent.agentrights || {};
      const canUpdateLead = !isDisabled(agentRights, "Update Lead");

      return canUpdateLead ? (
        <Link
          className="group relative inline-flex items-center overflow-hidden rounded bg-green px-4 py-1 text-white focus:outline-none active:bg-black"
          to={EDIT_LEAD_ROUTE + row.original.leadid}
        >
          <span className="absolute -start-full transition-all group-hover:start-4">
            <svg
              className="size-3 rtl:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </span>
          <span className="text-sm font-medium transition-all group-hover:ms-4">
            Edit
          </span>
        </Link>
      ) : (
        <Tooltip title="You don't have permission to edit leads">
          <span className="inline-flex items-center rounded bg-gray-400 px-4 py-1 text-white text-sm cursor-not-allowed opacity-60">
            Edit
          </span>
        </Tooltip>
      );
    },
  },
];

export const LEAD_HISTORY_COLUMNS = [
  {
    accessorKey: "leadStatus",
    header: "Status",
    size: 20,
    Cell: ({ row }) => (
      <div>
        {STATUS_TYPES.find((item) => item.id === row.original.leadStatus)?.name}
      </div>
    ),
  },
  {
    accessorKey: "leadDate",
    header: "Date",
    size: 20,
    Cell: ({ row }) => {
      const date = correctDate(row.original?.leadDate);
      return <div>{date}</div>;
    },
  },
  {
    accessorKey: "leadDate",
    header: "Time",
    size: 20,
    Cell: ({ row }) => {
      const leadDate = row.original.leadDate;
      if (leadDate) {
        const timeString = new Date(leadDate).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return timeString;
      } else {
        return "";
      }
    },
  },

  { accessorKey: "note", header: "Description", size: 20 },
];
